<template>
  <component :is="layout" v-if="layout" />
</template>

<script setup lang="ts">
import { computed, markRaw, onBeforeUnmount, shallowRef, type Component } from 'vue'
import { useRoute } from 'vue-router'
import router from '@/router'

type AppLayoutName = 'player' | 'default'

const route = useRoute()
const layouts = shallowRef<Partial<Record<AppLayoutName, Component>>>({})

const getAppLayout = (layoutName: unknown): AppLayoutName =>
  layoutName === 'Player' ? 'player' : 'default'

const layout = computed(() => layouts.value[getAppLayout(route.meta.layout)] ?? null)

const loadLayout = async (layoutName: AppLayoutName) => {
  if (layouts.value[layoutName]) return

  try {
    const module = layoutName === 'player'
      ? await import('./layouts/Player/PlayerLayout.vue')
      : await import('./layouts/Default/DefaultLayout.vue')
    layouts.value = { ...layouts.value, [layoutName]: markRaw(module.default) }
  } catch (error) {
    console.error('Failed to load layout:', error)
  }
}

const removeLayoutGuard = router.beforeEach(async (to) => {
  await loadLayout(getAppLayout(to.meta.layout))
})

onBeforeUnmount(() => {
  removeLayoutGuard()
})
</script>
